import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Index from "../views/Index.vue";
import Login from "../views/Login.vue";
import Settings from "@/modules/settings/Settings.vue";

import CalendarIndex from "@/modules/calendar/Calendar.vue";
import BrainIndex from "@/modules/brain/Brain.vue";
import ClothingMeassurement from "@/modules/clothing_meassurement/ClothingMeassurement.vue";
import ClothingMeassurementEdit from "@/modules/clothing_meassurement/ClothingMeassurementEdit.vue";
import CustomerIndex from "@/modules/customer/CustomerIndex.vue";
import CustomerView from "@/modules/customer/CustomerView.vue";
import PetIndex from "@/modules/pet/PetIndex.vue";
import PetView from "@/modules/pet/PetView.vue";

import NgineComposerIndex from "@/modules/ngine_composer/Index.vue";
import NgineDashboardIndex from "@/modules/ngine_dashboard/NgineDashboardIndex.vue";
import NgineDashboardReportViewer from "@/modules/ngine_dashboard/NgineDashboardReportViewer.vue";
import NgineDashboardComposer from "@/modules/ngine_dashboard/composer/NgineDashboardComposerIndex.vue";
import NgineComposerProjectIndex from "@/modules/ngine_composer/project/ProjectIndex.vue";
import NgineComposerProcessIndex from "@/modules/ngine_composer/process/ProcessIndex.vue";
import NgineComposerHumanTaskComposer from "@/modules/ngine_composer/human_task/HumanTaskCompose";
import NgineComposerHumanTaskTester from "@/modules/ngine_composer/human_task/tester/Index";
import NgineCoreIndex from "@/modules/ngine_core/NgineCoreIndex.vue";
import NgineWorkspaceIndex from "@/modules/ngine_workspace/NgineWorkspaceIndex.vue";
import NgineWorkspaceExternalTaskView from "@/modules/ngine_workspace/NgineWorkspaceExternalTaskViewer.vue";
import NgineWorkspaceExternalTaskStart from "@/modules/ngine_workspace/external_start/Index.vue";
//import NgineMonitorIndex from "@/modules/ngine_monitor/Index.vue";

import ProductIndex from "@/modules/product/ProductIndex.vue";
import ProductView from "@/modules/product/ProductView.vue";

import PointOfSaleIndex from "@/modules/point_of_sale/PointOfSaleIndex.vue";
import InventoryIndex from "@/modules/inventory/InventoryIndex.vue";

import ArcheologyIndex from "@/modules/archeology/ArcheologyIndex.vue";
import ArcheologyCatalog from "@/modules/archeology/ArcheologyCatalog.vue";
import ArcheologyPieceView from "@/modules/archeology/ArcheologyPieceView.vue";

import ProviderIndex from "@/modules/provider/ProviderIndex.vue";

import SupportControlIndex from "@/modules/support_control/SupportControlIndex.vue";
import SupportControlExternalView from "@/modules/support_control/external/SupportControlExternalView.vue";

import APIManagerIndex from "@/modules/api_manager/APIManagerIndex.vue";

import ModulManagerIndex from "@/modules/modul_manager/ModulManagerIndex.vue";

import ReportIndex from "@/modules/report/ReportIndex.vue";
import ReportViewer from "@/modules/report/ReportViewer.vue";
import ReportAnonymousViewer from "@/modules/report/ReportAnonymousViewer.vue";
import ReportComposer from "@/modules/report/composer/ReportComposerIndex.vue";

import OrganizationChartIndex from "@/modules/organization_chart/OrganizationChartIndex.vue";

import StudentIndex from "@/modules/student/StudentIndex.vue";
import StudentView from "@/modules/student/view/Index.vue";

import AccountIndex from "@/modules/account/AccountIndex.vue";
import AccountsView from "@/modules/account/view/AccountView.vue";

import FoodOrderIndex from "@/modules/food_order/FoodOrderIndex.vue";

import RobotIndex from "@/modules/robot/RobotIndex.vue";

import QuotationIndex from "@/modules/quotation/QuotationIndex.vue";
import QuotationComposerIndex from "@/modules/quotation/composer/QuotationComposerIndex.vue";

import StudentPortalIndex from "@/modules/student_portal/admin_panel/StudentPortalIndex.vue";
import StudentPortalPublicIndex from "@/modules/student_portal/public/StudentPortalPublicIndex.vue";
import StudentPortalPublicHome from "@/modules/student_portal/public/StudentPortalPublicHome.vue";
import StudentPortalPublicLogin from "@/modules/student_portal/public/Login.vue";
import StudentPortalPublicPasswordRecovery from "@/modules/student_portal/public/PasswordRecovery.vue";
import StudentPortalAccountIndex from "@/modules/student_portal_account/Index.vue";
import StudentPortalVisaPaymentIndex from "@/modules/student_portal_visa_payment/Index.vue";

import VisaPaymentIndex from "@/modules/visa_payment/Index.vue";
import OnfidoConnectIndex from "@/modules/onfido_connect/Index.vue";

import PrototypeIndex from "@/modules/prototype/Index.vue";
import PrototypeComposer from "@/modules/prototype/composer/Index.vue";
import PrototypeViewer from "@/modules/prototype/viewer/Index.vue";
import PrototypePageViewer from "@/modules/prototype/viewer/Page.vue";
// import VirtualModuleProjectIndex from "@/modules/prototype/project/ProjectIndex.vue";

import PixelArtIndex from "@/modules/pixel_art/Index.vue";
import PixelArtProjectIndex from "@/modules/pixel_art/project/Index.vue";

import FelGtIndex from "@/modules/fel_gt/Index.vue";

import NvidiaBundleIndex from "@/modules/nvidia_bundle/Index.vue";
import NvidiaTicketIndex from "@/modules/nvidia_ticket/Index.vue";
import NvidiaTicketStoreIndex from "@/modules/nvidia_ticket/store/Index.vue";

import NworkforceStore from "@/modules/nworkforce/store/Index.vue";
import NworkforceNvidia1 from "@/modules/nworkforce/nvidia1/Index.vue";

import NworkforceStoreIndex from "@/modules/nworkforce_store/Index.vue";
import NworkforceNvidiaIndex from "@/modules/nworkforce_nvidia/Index.vue";
import NworkforceExchangeIndex from "@/modules/nworkforce_exchange/Index.vue";
import NworkforceExchangePublic from "@/modules/nworkforce_exchange/Public.vue";

import CourseIndex from "@/modules/course/Index.vue";
import CourseAssignationIndex from "@/modules/course_assignation/Index.vue";
import CourseAssignationDistribution from "@/modules/course_assignation/distribution/DistributionIndex.vue";
import CourseAssignationRevision from "@/modules/course_assignation/revision/RevisionIndex.vue";
import CourseScoringIndex from "@/modules/course_scoring/Index.vue";
import CourseScoringRevision from "@/modules/course_scoring/revision/RevisionIndex.vue";
import CourseScoringEdit from "@/modules/course_scoring/edit/EditIndex.vue";

import RobocreditIndex from "@/modules/robocredit/Index.vue";
import RobocreditNewCustomersIndex from "@/modules/robocredit/new_customers/Index.vue";
import RobocreditExistingCustomersIndex from "@/modules/robocredit/existing_customers/Index.vue";
import RobocreditCatalogs from "@/modules/robocredit/catalogs/Index.vue";

import TibixIndex from "@/modules/tibix/Index.vue";

import OutboxIndex from "@/modules/outbox/Index.vue";
import OutboxMessages from "@/modules/outbox/Messages.vue";

//pensum

import PensumIndex from "@/modules/pensum/PensumIndex.vue";

//professors
import ProfessoreIndex from "@/modules/professor/Index.vue";

// Short.io
import ShortioIndex from "@/modules/shortio/Index.vue";

// Visalink
import VisalinkIndex from "@/modules/visalink/Index.vue";

// Visalink generator
import VisalinkGeneratorIndex from "@/modules/visalink_generator/Index.vue";
import VisalinkGeneratorBulkIndex from "@/modules/visalink_generator/bulk/Index.vue";

// Couse record
import CourseRecordIndex from "@/modules/course_record/Index.vue";

// Serbipagos
import SerbipagosIndex from "@/modules/serbipagos/Index.vue";

// 360 feedback
import Feedback360Index from "@/modules/feedback360/Index.vue";
import Feedback360ThreeManagement from "@/modules/feedback360/tree_management/Index.vue";
import Feedback360SurveyManagement from "@/modules/feedback360/survey_management/Index.vue";
import Feedback360Run from "@/modules/feedback360/run/Run.vue";

// Feedback survey
import Feedback360SurveyIndex from "@/modules/feedback360_survey/Index.vue";

// Survey
import SurveyIndex from "@/modules/survey/Index.vue";
import SurveyTemplateManager from "@/modules/survey/template_manager/Index.vue";

// Cooldown
import CooldownIndex from "@/modules/cooldown/Index.vue";
import CooldownRegister from "@/modules/cooldown/register/Index.vue";

// Teacher rating
import TeacherRatingIndex from "@/modules/teacher_rating/Index.vue";

// Staff rating
import StaffRatingIndex from "@/modules/staff_rating/Index.vue";
import StaffRatingTemplateIndex from "@/modules/staff_rating/template/Index.vue";
import StaffRatingOrganizationIndex from "@/modules/staff_rating/organization/Index.vue";
import StaffRatingTeacherOrganizationIndex from "@/modules/staff_rating/teacher_organization/Index.vue";
import StaffRating360FeedbackIndex from "@/modules/staff_rating/360_feedback/Index.vue";
import StaffRating360FeedbackDeployments from "@/modules/staff_rating/360_feedback/Deployments.vue";
import StaffRating360EvaluationIndex from "@/modules/staff_rating/360_evaluation/Index.vue";
import StaffRating360EvaluationRun from "@/modules/staff_rating/360_evaluation/run/Run.vue";
import StaffRatingTeacherIndex from "@/modules/staff_rating/teacher/Index.vue";

// Project
import ProjectIndex from "@/modules/project/Index.vue";

// Multimoney Staff
import MultimoneyStaffIndex from "@/modules/multimoney_staff/Index.vue";
import MultimoneyStaffAdmin from "@/modules/multimoney_staff/Admin.vue";
import MultimoneyStaffOrganization from "@/modules/multimoney_staff/Organization.vue";

// Automation
import AutomationIndex from "@/modules/automation/Index.vue";
import AutomationTasks from "@/modules/automation/Tasks.vue";

// Intercable billing
import IntercableBillingIndex from "@/modules/intercable_billing/Index.vue";

/** End import modules */

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/calendar",
    name: "CalendarIndex",
    component: CalendarIndex,
  },
  {
    path: "/brain",
    name: "BrainIndex",
    component: BrainIndex,
  },
  {
    path: "/clothing_meassurement",
    name: "ClothingMeassurement",
    component: ClothingMeassurement,
  },
  {
    path: "/clothing_meassurement/edit",
    name: "ClothingMeassurementEdit",
    component: ClothingMeassurementEdit,
  },
  {
    path: "/customer",
    name: "CustomerIndex",
    component: CustomerIndex,
  },
  {
    path: "/customer/view",
    name: "CustomerView",
    component: CustomerView,
  },
  {
    path: "/pet",
    name: "PetIndex",
    component: PetIndex,
  },
  {
    path: "/pet/view",
    name: "PetView",
    component: PetView,
  },
  {
    path: "/product",
    name: "ProductIndex",
    component: ProductIndex,
  },
  {
    path: "/product/view",
    name: "ProductView",
    component: ProductView,
  },
  {
    path: "/ngine_composer",
    name: "NgineComposerIndex",
    component: NgineComposerIndex,
  },
  {
    path: "/ngine_composer/project/",
    name: "NgineComposerProjectIndex",
    component: NgineComposerProjectIndex,
  },
  {
    path: "/ngine_composer/process/",
    name: "NgineComposerProcessIndex",
    component: NgineComposerProcessIndex,
  },
  {
    path: "/ngine_composer/human_task/compose/",
    name: "NgineComposerHumanTaskComposer",
    component: NgineComposerHumanTaskComposer,
  },
  {
    path: "/ngine_composer/human_task/test",
    name: "NgineComposerHumanTaskTester",
    component: NgineComposerHumanTaskTester,
  },
  {
    path: "/ngine_core",
    name: "NgineCoreIndex",
    component: NgineCoreIndex,
  },
  {
    path: "/ngine_workspace",
    name: "NgineWorkspaceIndex",
    component: NgineWorkspaceIndex,
  },
  {
    path: "/ngine_workspace/external",
    name: "NgineWorkspaceExternalTaskVue",
    component: NgineWorkspaceExternalTaskView,
  },
  {
    path: "/ngine_workspace/external_start",
    name: "NgineWorkspaceExternalTaskStartVue",
    component: NgineWorkspaceExternalTaskStart,
  },
  {
    path: "/ngine_dashboard",
    name: "NgineDashboardIndex",
    component: NgineDashboardIndex,
  },
  {
    path: "/ngine_dashboard/report_viewer",
    name: "NgineDashboardReportViewer",
    component: NgineDashboardReportViewer,
  },
  {
    path: "/ngine_dashboard/composer",
    name: "NgineDashboardComposer",
    component: NgineDashboardComposer,
  },
  //{
  //  path: "/ngine_monitor",
  //  name: "NgineMonitorIndex",
  //  component: NgineMonitorIndex,
  //},
  {
    path: "/pos",
    name: "PointOfSaleIndex",
    component: PointOfSaleIndex,
  },
  {
    path: "/inventory",
    name: "InventoryIndex",
    component: InventoryIndex,
  },
  {
    path: "/archeology",
    name: "ArcheologyIndex",
    component: ArcheologyIndex,
  },
  {
    path: "/archeology/catalog",
    name: "ArcheologyCatalog",
    component: ArcheologyCatalog,
  },
  {
    path: "/archeology/piece_view",
    name: "ArcheologyPieceView",
    component: ArcheologyPieceView,
  },
  {
    path: "/provider",
    name: "ProviderIndex",
    component: ProviderIndex,
  },
  {
    path: "/support_control",
    name: "SupportControlIndex",
    component: SupportControlIndex,
  },
  {
    path: "/support_control/external",
    name: "SupportControlExternalView",
    component: SupportControlExternalView,
  },
  {
    path: "/modul_manager",
    name: "ModulManagerIndex",
    component: ModulManagerIndex,
  },
  {
    path: "/report",
    name: "ReportIndex",
    component: ReportIndex,
  },
  {
    path: "/report/composer",
    name: "ReportComposer",
    component: ReportComposer,
  },
  {
    path: "/report/viewer",
    name: "ReportViewer",
    component: ReportViewer,
  },
  {
    path: "/report/anonymous",
    name: "ReportAnonymousViewer",
    component: ReportAnonymousViewer,
  },
  {
    path: "/organization_chart",
    name: "OrganizationChartIndex",
    component: OrganizationChartIndex,
  },
  {
    path: "/api_manager",
    name: "APIManagerIndex",
    component: APIManagerIndex,
  },
  {
    path: "/student",
    name: "StudentIndex",
    component: StudentIndex,
  },
  {
    path: "/student/view",
    name: "StudentView",
    component: StudentView,
  },
  {
    path: "/account",
    name: "AccountIndex",
    component: AccountIndex,
  },
  {
    path: "/accounts/view",
    name: "AccountsView",
    component: AccountsView,
  },
  {
    path: "/food_order",
    name: "FoodOrderIndex",
    component: FoodOrderIndex,
  },
  {
    path: "/robot",
    name: "RobotIndex",
    component: RobotIndex,
  },
  {
    path: "/quotation",
    name: "QuotationIndex",
    component: QuotationIndex,
  },
  {
    path: "/quotation/composer",
    name: "QuotationComposerIndex",
    component: QuotationComposerIndex,
  },
  {
    path: "/student_portal",
    name: "StudentPortalIndex",
    component: StudentPortalIndex,
  },
  {
    path: "/student_portal/public",
    name: "StudentPortalPublicIndex",
    component: StudentPortalPublicIndex,
  },
  {
    path: "/student_portal/public/home",
    name: "StudentPortalPublicHome",
    component: StudentPortalPublicHome,
  },
  {
    path: "/student_portal/public/login",
    name: "StudentPortalPublicLogin",
    component: StudentPortalPublicLogin,
  },
  {
    path: "/student_portal/public/password_reset",
    name: "StudentPortalPublicPasswordRecovery",
    component: StudentPortalPublicPasswordRecovery,
  },
  {
    path: "/student_portal/public/account",
    name: "StudentPortalAccountIndex",
    component: StudentPortalAccountIndex,
  },
  {
    path: "/student_portal/public/visa_payment",
    name: "StudentPortalVisaPaymentIndex",
    component: StudentPortalVisaPaymentIndex,
  },
  {
    path: "/visa_payment",
    name: "VisaPaymentIndex",
    component: VisaPaymentIndex,
  },
  {
    path: "/onfido_connect",
    name: "OnfidoConnectIndex",
    component: OnfidoConnectIndex,
  },
  {
    path: "/prototype",
    name: "PrototypeIndex",
    component: PrototypeIndex,
  },
  {
    path: "/prototype/composer/",
    name: "PrototypeComposer",
    component: PrototypeComposer,
  },
  {
    path: "/prototype/viewer/",
    name: "PrototypeViewer",
    component: PrototypeViewer,
  },
  {
    path: "/prototype/page_viewer/",
    name: "PrototypePageViewer",
    component: PrototypePageViewer,
  },
  {
    path: "/pixel_art",
    name: "PixelArtIndex",
    component: PixelArtIndex,
  },
  {
    path: "/pixel_art/project",
    name: "PixelArtProjectIndex",
    component: PixelArtProjectIndex,
  },
  {
    path: "/fel_gt",
    name: "FelGtIndex",
    component: FelGtIndex,
  },
  {
    path: "/nvidia_bundle",
    name: "NvidiaBundleIndex",
    component: NvidiaBundleIndex,
  },
  {
    path: "/nvidia_ticket",
    name: "NvidiaTicketIndex",
    component: NvidiaTicketIndex,
  },
  {
    path: "/nvidia_ticket/store",
    name: "NvidiaTicketTiendaIndex",
    component: NvidiaTicketStoreIndex,
  },
  {
    path: "/course",
    name: "CourseIndex",
    component: CourseIndex,
  },
  {
    path: "/course_assignation",
    name: "CourseAssignationIndex",
    component: CourseAssignationIndex,
  },
  {
    path: "/course_assignation/distribution",
    name: "CourseAssignationDistribution",
    component: CourseAssignationDistribution,
  },
  {
    path: "/course_assignation/revision",
    name: "CourseAssignationRevision",
    component: CourseAssignationRevision,
  },
  {
    path: "/nworkforce/store",
    name: "NworkforceStore",
    component: NworkforceStore,
  },
  {
    path: "/nworkforce/nvidia1",
    name: "NworkforceNvidia1",
    component: NworkforceNvidia1,
  },
  {
    path: "/nworkforce_store",
    name: "NworkforceStoreIndex",
    component: NworkforceStoreIndex,
  },
  {
    path: "/nworkforce_nvidia",
    name: "NworkforceNvidiaIndex",
    component: NworkforceNvidiaIndex,
  },
  {
    path: "/nworkforce_exchange",
    name: "NworkforceExchangeIndex",
    component: NworkforceExchangeIndex,
  },
  {
    path: "/nworkforce_exchange/public",
    name: "NworkforceExchangePublic",
    component: NworkforceExchangePublic,
  },
  {
    path: "/robocredit",
    name: "RobocreditIndex",
    component: RobocreditIndex,
  },
  {
    path: "/robocredit/new_customers",
    name: "RobocreditNewCustomers",
    component: RobocreditNewCustomersIndex,
  },
  {
    path: "/robocredit/existing_customers",
    name: "RobocreditExistingCustomers",
    component: RobocreditExistingCustomersIndex,
  },
  {
    path: "/robocredit/catalogs",
    name: "RobocreditCatalogs",
    component: RobocreditCatalogs,
  },
  {
    path: "/pensum",
    name: "PensumIndex",
    component: PensumIndex,
  },
  {
    path: "/course_scoring",
    name: "CourseScoringIndex",
    component: CourseScoringIndex,
  },
  {
    path: "/course_scoring/revision",
    name: "CourseScoringRevision",
    component: CourseScoringRevision,
  },
  {
    path: "/course_scoring/edit",
    name: "CourseScoringEdit",
    component: CourseScoringEdit,
  },
  {
    path: "/professor",
    name: "ProfessorIndex",
    component: ProfessoreIndex,
  },
  {
    path: "/tibix",
    name: "TibixIndex",
    component: TibixIndex,
  },
  {
    path: "/outbox",
    name: "OutboxIndex",
    component: OutboxIndex,
  },
  {
    path: "/outbox_messages",
    name: "OutboxMessages",
    component: OutboxMessages,
  },
  {
    path: "/shortio",
    name: "ShortioIndex",
    component: ShortioIndex,
  },
  {
    path: "/visalink",
    name: "VisalinkIndex",
    component: VisalinkIndex,
  },
  {
    path: "/visalink_generator",
    name: "VisalinkGeneratorIndex",
    component: VisalinkGeneratorIndex,
  },
  {
    path: "/visalink_generator/bulk",
    name: "VisalinkGeneratorBulkIndex",
    component: VisalinkGeneratorBulkIndex,
  },
  {
    path: "/course_record",
    name: "CourseRecordIndex",
    component: CourseRecordIndex,
  },
  {
    path: "/serbipagos",
    name: "SerbipagosIndex",
    component: SerbipagosIndex,
  },
  {
    path: "/feedback360",
    name: "Feedback360Index",
    component: Feedback360Index,
  },
  {
    path: "/feedback360/tree_management",
    name: "Feedback360ThreeManagement",
    component: Feedback360ThreeManagement,
  },
  {
    path: "/feedback360/survey_management",
    name: "Feedback360SurveyManagement",
    component: Feedback360SurveyManagement,
  },
  {
    path: "/feedback360/run",
    name: "Feedback360Run",
    component: Feedback360Run,
  },
  {
    path: "/feedback360_survey",
    name: "Feedback360SurveyIndex",
    component: Feedback360SurveyIndex,
  },
  {
    path: "/survey",
    name: "SurveyIndex",
    component: SurveyIndex,
  },
  {
    path: "/survey/template_manager",
    name: "SurveyTemplateManager",
    component: SurveyTemplateManager,
  },
  {
    path: "/cooldown",
    name: "CooldownIndex",
    component: CooldownIndex,
  },
  {
    path: "/cooldown/register",
    name: "CooldownRegister",
    component: CooldownRegister,
  },
  {
    path: "/teacher_rating",
    name: "TeacherRatingIndex",
    component: TeacherRatingIndex,
  },
  {
    path: "/staff_rating",
    name: "StaffRatingIndex",
    component: StaffRatingIndex,
  },
  {
    path: "/staff_rating/template",
    name: "StaffRatingTemplateIndex",
    component: StaffRatingTemplateIndex,
  },
  {
    path: "/staff_rating/organization",
    name: "StaffRatingOrganizationIndex",
    component: StaffRatingOrganizationIndex,
  },
  {
    path: "/staff_rating/teacher_organization",
    name: "StaffRatingTeacherOrganizationIndex",
    component: StaffRatingTeacherOrganizationIndex,
  },
  {
    path: "/staff_rating/360_feedback",
    name: "StaffRating360FeedbackIndex",
    component: StaffRating360FeedbackIndex,
  },
  {
    path: "/staff_rating/360_deployments",
    name: "StaffRating360FeedbackDeployments",
    component: StaffRating360FeedbackDeployments,
  },
  {
    path: "/staff_rating/360_evaluation",
    name: "StaffRating360EvaluationIndex",
    component: StaffRating360EvaluationIndex,
  },
  {
    path: "/staff_rating/360_evaluation/run",
    name: "StaffRating360EvaluationRun",
    component: StaffRating360EvaluationRun,
  },
  {
    path: "/staff_rating/teacher",
    name: "StaffRatingTeacherIndex",
    component: StaffRatingTeacherIndex,
  },
  {
    path: "/project",
    name: "ProjectIndex",
    component: ProjectIndex,
  },
  {
    path: "/multimoney_staff",
    name: "MultimoneyStaffIndex",
    component: MultimoneyStaffIndex,
  },
  {
    path: "/multimoney_staff/admin",
    name: "MultimoneyStaffAdmin",
    component: MultimoneyStaffAdmin,
  },
  {
    path: "/multimoney_staff/organization",
    name: "MultimoneyStaffOrganization",
    component: MultimoneyStaffOrganization,
  },
  {
    path: "/automation",
    name: "AutomationIndex",
    component: AutomationIndex,
  },
  {
    path: "/automation/tasks",
    name: "AutomationTasks",
    component: AutomationTasks,
  },
  {
    path: "/intercable_billing",
    name: "IntercableBillingIndex",
    component: IntercableBillingIndex,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
